import React, { useRef } from 'react'
import { useCopy } from '../../shared/clipboard/clipboard'
import { LmsIcon } from './lms-icon'

// A value the admin pastes somewhere else, shown whole in a mono box with a
// Copy button (an LTI tool address, a course's custom parameter). The copy
// starts inside the click and says "Copied" only once the text really reached
// the clipboard; when the browser refuses, the value is selected and the
// shortcut is named (shared/clipboard, useCopy).
export const CopyLine = ({ testId, label, value, help }) => {
  const copy = useCopy()
  const text = useRef(null)
  return (
    <div className="field copy-line" data-testid={testId}>
      <div className="field-label">
        <span className="name">{label}</span>
      </div>
      <div className="copy-line-row">
        <code className="copy-line-value" ref={text} data-testid={`${testId}-value`}>
          {value}
        </code>
        <button
          className="btn btn-outline-secondary btn-sm"
          type="button"
          aria-label={`Copy ${label}`}
          data-testid={`${testId}-copy`}
          onClick={() => copy.copy(value, text)}
        >
          <LmsIcon name={copy.copied ? 'check' : 'copy'} className="me-1" />
          {copy.copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      {copy.manual && (
        <div className="field-help" role="status">
          {copy.hint}
        </div>
      )}
      {help && <div className="field-help">{help}</div>}
    </div>
  )
}
